module.exports = {
  menue: {
    detail: "SocialDetails",
    porj: "PresetProject",
    domesticChance: "Domestic Chance",
    socialConcept: "Social Concept",
    ECConcept: "EC Concept",
    brand: "growth brand",
    category: "growth category",
    ebay: "ebay growth concept",
    overseaChance: "Oversea Chance",
    amazon: "Amazon growth concept",
    overseaBrand: "oversea growth brand",
    overseaCategory: "oversea growth category",
    mark: "My attention",
    report: "Research",
    set: "Set up",
    back_cmi: "back to CMI",
    ai: "AI cost efficiency",
  },
  topHead: {
    contact_us: "Contact Us",
    QRcode_contact: "Scan the code to contact the after-sales staff",
    product_question: "Encountering issues with product usage!",
    scan_code:
      "You can scan the code to apply for product explanation or training",
    apply_for: "Apply for",
    select_option_concept: "Concept",
    select_option_brand: "Brand",
    select_option_category: "Category",
    select_option_ebay: "Ebay",
    select_option_amazon: "Amazon",
    select_option_holder: "Please select",
    select_option_concept_holder: "Please enter the concept word",
    search_tooltip1:
      "Support the use of filtering criteria such as 'and', 'or', and 'not', separated from concepts by spaces.",
    search_tooltip2:
      "For example, 'Xiaomi and Huawei' means that the product title contains both 'Xiaomi' and 'Huawei'",
    search_tooltip3:
      "'Xiaomi or Huawei' means that the product title 'Xiaomi' or 'Huawei' includes at least one of them",
    search_tooltip4:
      "'Xiaomi not Huawei' means that the product title includes' Xiaomi 'but not' Huawei '",
    my_attention: "MyAttention",
    login_label: "SignIn",
    login_out: "SignOut",
    Chinese: "中文",
    English: "English",
  },
  mainHead: {
    eidtTooltip: "Edit search criteria",
    platList_weibo: "Micro Blog",
    platList_douyin: "Tik Tok",
    platList_xhs: "Red Booklet",
    dateLabel: "Date",
    date_to: "To",
    date_holder: "Select month",
    saveProj: "Save scheme",
    follow: "follow",
    tabs_trend: "Summary & Trends",
    tabs_category: "Top category",
    tabs_category_son: "Top leaf category",
    tabs_brand: "Top brand",
    tabs_commodity: "Top commodity",
    tabs_baseInfo: "BaseInfo",
    tabs_talents: "Talent list",
    rules_message_search: "Please enter concept word search",
    rules_message_search2:
      "At least one of the brand or post content is not empty",
    rules_message_range: "Time range cannot be empty",
    message_saveProj_success: "Scheme saved successfully",
    message_saveProj_failed: "Failed to save scheme",
  },
  mainHeader: {
    no_discount: "No discount",
    discount_v1: "Discount v1",
    full_discount_v2: "Full discount v2",
  },
  search: {
    title: "Add search criteria",
    form_postWord: "Concept word",
    form_postWord_tip:
      "Support and, or, not logic, and word segmentation are separated by spaces; For example: lipstick and (Lip Glaze or lip gloss) not matte",
    form_brand: "Brand",
    form_brand_holder: "Enter brand keywords",
    form_brand_tip:
      "For example, searching for the brand 'apple / Apple' will filter out the posts containing 'Apple' or 'Apple' or 'apple / Apple', and the posts representing 'apple / Apple' can be determined through semantic analysis.",
    form_plat: "Platform",
    form_platOption_douyin: "Tik Tok",
    form_platOption_weibo: "Micro Blog",
    form_platOption_xhs: "Red Booklet",
    form_dateRange: "TimeRange",
    form_dateRange_holder: "Select month",
    form_dateRange_to: "To",
    searchBtnLab: "Search",
    operation: "Operation",
  },
  baseInfo: {
    kols: "author",
    contentForKols:
      "Tiktok is more than 5w, Weibo is more than 10w, and Xiaohongshu is more than 1w",
    trend: "trend",
    posts: "Post",
    posts_toolTip: "Number of All Posts",
    interaction: "Interaction",
    interaction_toolTip: "Comments + Likes + Forwards",
    platTitle: "Platform distribution",
    cloudWordTitle: "WordCloud",
    TalentTitle: "Top 10 list of talents",
    PostListLabel: "Volume ranking",
    IteractionListLabel: "Interaction ranking",
    BrandTitle: "Brand top 10 list",
    postContent: "Original post",
    postType_Forward: "Positive",
    postType_back: "Negative",
    selectedCondition: "Selected Conditions",
    postKeyWordLabel: "Concept word:",
    cloudWordLabel: "CloudWord:",
    kolLabel: "KOL:",
    brandLabel: "Brand:",
    brand: "Brand",
    originPostLink: "Posts Link",
    negativePostPercent: "Proportion of negative posts",
    reposts: "Forwarding",
    comments: "Comments",
    zans: "Likes",
    participle: "Participle",
    frequency: "Frequency",
    photo: "Photo",
    Talent: "Talent",
    plant: "platform",
    fansNum: "FansNum",
    downLoad: "DownLoad",
    downLoading: "DownLoading...",
    ranking: "Ranking",
    cloud_select_word: "Word & two-tuple",
    cloud_nameLabel: "word",
    cloud_valueLabel: "count",
    unfollow: "unfollow",
    category: "Category",
    soldAmount: "Sales",
    sales: "Sold",
    itemNum: "Item Num",
    goodsNum: "Goods Num",
    shopNum: "Shop Num",
    average: "Average Price",
    averagePrice: "Average price",
    yoy_growth: "Year on year growth rate",
    now: "Sales for the month",
    multi_month: "Sales for three months",
    last: "Sales in the same period last year",
    classification: "Classification",
    zero: "0",
    consumer: "Consumers",
    contentForConsumer: "Number of fans ≤ 100",
    tipsForFilter:
      "Category and brand filter conditions are not valid for social modules",
    contentForTips:
      "If you search for 'category>sugar free' or 'category>brand>sugar free', you will use 'sugar free' as the keyword to search for posts that contain the word 'sugar free'",
    authorNum: "Number of authors",
    postNum: "Number of volumes",
    volumeYoyGrowth: "Year on year growth rate of volume",
    likeNum: "Number of likes",
    commentNum: "Number of comments",
    commentYoyGrowth: "Year on year growth rate of comment",
    followerNum: "Number of followers",
    interactionVolume: "Interaction volume",
    interactionYoyGrowth: "Year on year growth rate of interaction volume",
    forwardNum: "Number of forwards",
    productDesc: "Product Description",
    picture: "Picture",
    itemTitle: "Item Title",
    lastQuarter: "Sales in the previous quarter",
    price: "Price",
    recently: "Recently",
    random: "Random",
    thousand: "1,000 pieces",
    tenThousand: "10,000 pieces",
    lakh: "100000 pieces (slower)",
  },
  TalentList: {
    allPosts: "All Posts",
    forwardPosts: "Positive Posts",
    backPosts: "Negative Posts",
  },
  describeTitle: {
    saleSummary: "Sales summary",
    searchCondition: "Product search condition",
    searchTitleWord: "The product title includes",
    realCalculate: "Real-time computing version",
    precomputation: "Precomputation version",
    inAdvanceText:
      "In the concept discovery stage, we use AI algorithms to perform calculations on massive amounts of data, which is expensive. Therefore, partial approximations are made during the calculation process, resulting in some differences between the pre computed version and the real-time computed version above. However, this difference does not affect the discovery and discrimination of high growth concepts. Please refer to the real-time calculation results above for specific data under this concept.",
    socialSummary: "Social summary",
    socialSearchCondition: "Social search condition",
    postContent: "Post content",
    searchCategoryRange: "Search category range",
    saleTrend: "Sale trend",
    sale: "Sale",
    trend: "Trend",
    spreading: "Spreading",
    productKeywaod: "Product title high frequency keywords",
    socialplatformshare: "Social platform share",
    highFreWords: "Related High Frequency Phrases",
    voiceOfReviews: "The voice in all aspects of e-commerce reviews",
    keywordsOfReviews: "High frequency keywords for e-commerce reviews",
  },
  proj: {
    title: "Preset Project",
    userDefinedName: "Custom name",
    postsKeyWords: "Post keyword",
    brand: "Brand",
    Talent: "Talent",
    plant: "platform",
    date: "Date",
    to: " To ",
  },
  tableTh: {
    suggest: "Suggest",
    concept: "Concept",
    previous_quarter: "Sales in the same period of the previous quarter",
    now: "Sales for the month",
    multi_month: "Sales for three months",
    last: "Sales in the same period last year",
    yoy_growth: "Year on year growth rate",
    market_growth: "Market growth rate",
    commodity_sample: "Commodity sample",
    average: "Average price of goods",
    market_average: "Average market price",
    desc: "Product description",
    trend_chart: "Sales trends in the past 12 months",
    category: "Category",
    route: "Route",
    hierarchy: "Hierarchy",
    relevant_category: "Relevant category",
    classification: "Classification",
    brand: "Brand",
    beyond_market: "Beyond the market(alpha)",
    category_son: "Leaf category",
  },
  tableThTip: {
    sift: "Sift",
    select_all: "Select all",
    confirm: "confirm",
    suggest: "Suggest",
    not_suggest: "Not suggest",
    recommend: "Recommend",
    not_recommend: "Not recommend",
    trash_can: "Trash can",
    concept_toolTip:
      "The word combination that appears many times in a large number of commodities and has obvious total sales volume is not necessarily a word with existing meaning. Analysts may need to infer and summarize the commodity characteristics and opportunity points revealed by it in combination with conceptual details。",
    trend_chart_toolTip:
      "The total sales of all goods with this concept word in the title from the selected month counting back 12 months",
    now_toolTip:
      "The total sales of all goods with this concept word in the title in the current month",
    last_toolTip:
      "Total sales of all goods with this concept in the title in the current month of last year",
    yoy_growth_toolTip:
      "Total sales in the current month / sales in the same period last year - 1",
    commodity_sample_toolTip:
      "The title contains some commodities (random sampling) of this concept word to help analysts infer the commodity characteristics actually revealed by this concept",
    average_toolTip:
      "The average price of some commodities (random sampling) with this concept word in the title",
    desc_toolTip:
      "Words with high frequency of occurrence extracted from some commodities (random sampling) containing this concept word in the title help analysts infer the commodity characteristics actually revealed by this concept",
    relevant_category_toolTip:
      "All calculations of this record are carried out in this first level category. We only find the concept of high growth under each primary category",
    brand_now_toolTip: "Total sales of this brand in the current month",
    category_now_toolTip: "Total sales of this category in the current month",
    brand_last_toolTip:
      "Total sales of this brand in the current month of last year",
    category_last_toolTip:
      "Total sales of this category in the current month of last year",
    brand_beyond_market_toolTip:
      "Year on year growth rate - market growth rate",
    brand_market_growth_toolTip:
      "Weighted average of the year-on-year growth rate of the total sales of each main leaf category of this brand \n for example: \n there are two leaf categories A1 and A2 under category a \n a brand has a total sales of 100W under Category A, of which: \n - A1 sales 40W, weight 0.4 \n - A2 sales 60W, The weight is 0.6 \n the growth rate of each leaf category in the current month is: \n - leaf category A1: 70% \n - leaf category A2: 15% \n the market growth rate of the brand under Category A is: \n 0 4*70%+0.6*15%=37%",
    category_market_growth_toolTip:
      "The year-on-year growth rate of the total sales corresponding to the parent category",
    brand_market_average_toolTip: "Average price of market goods of this brand",
    category_market_average_toolTip:
      "Average price of goods in such destination market",
    previous_quarter_toolTip:
      "The total sales of all products with this concept in the title in the corresponding month of the previous quarter",
    ebay_yoy_growth_toolTip:
      "Total sales of the current month / sales of the same period in the previous quarter - 1",
    ebay_market_growth_toolTip:
      "This keyword is the weighted average of the year-on-year growth rate of the total sales of each main leaf category",
    concept_table_tip:
      "The data on the list page is fuzzy and may differ from the data on the detail page. The data on the detail page shall prevail",
    volume_char_tip1:
      "The numbers in parentheses for all volume, positive volume, and negative volume represent the proportion of volume in each aspect.",
    volume_char_tip2:
      "Total volume - proportion of volume in each aspect: total volume in this aspect divided by total volume * 100%.",
    volume_char_tip3:
      "Positive volume - proportion of aspect volume: the number of positive volumes in this aspect divided by the total number of positive volumes multiplied by 100%.",
    volume_char_tip4:
      "Negative volume - proportion of aspect volume: the number of negative volumes in this aspect divided by all negative volumes multiplied by 100%.",
    volume_char_tip5: "Currently only covering Tmall or JD platforms",
    allVolume: "All volume",
    posVolume: "Positive volume",
    negVolume: "Negative volume",
    negRate: "Negative rate",
    word_cloud_tip1: "There are multiple rules for generating word clouds:",
    word_cloud_tip2:
      "Word: Split the volume clauses that meet the filtering criteria into words.",
    word_cloud_tip3:
      "Two-tuple: Split the volume clauses that meet the filtering criteria into a combination of two adjacent words.",
    word_cloud_tip4: "Example: Volume clause: 'JD Express is very fast'",
    word_cloud_tip5:
      "According to the first rule, it will be split into three words: 'JD', 'Express', and 'Soon'.",
    word_cloud_tip6:
      "According to the second rule, it will be split into two tuples: 'JD Express' and 'Express Very Fast'.",
  },
  headSearch: {
    // 增加平台选项,可以选择显示淘系或者京东数据
    plat: "platform",
    amazon_us: "Amazon US",
    amazon_jp: "Amazon Japan",
    shopee_my: "Shopee Malaysia",
    shopee_sg: "Shopee Singapore",
    shopee_id: "Shopee Indonesia",
    shopee_ph: "Shopee Philippine",
    shopee_th: "Shopee Thailand",
    shopee_vn: "Shopee Vietnam",
    lazada_my: "Lazada Malaysia",
    lazada_sg: "Lazada Singapore",
    lazada_id: "Lazada Indonesia",
    lazada_ph: "Lazada Philippine",
    lazada_th: "Lazada Thailand",
    lazada_vn: "Lazada Vietnam",
    select_option_taobao: "taobao & tmall",
    select_option_JD: "JD",
    select_option_tbjd: "taobao & tmall & JD",
    select_option_tbjddy: "taobao & tmall & JD & douyin",
    select_option_gamazon: "Amazon",
    select_option_weibo_xhs_douyin: "weibo & xhs & douyin",
    select_option_weibo: "weibo",
    select_option_douyin: "douyin",
    select_option_xhs: "xhs",
    all: "All",
    no: "No label",
    query: "query",
    monthAll: "All in the current month",
    monthAdd: "New in the current month",
    recommend: "Analyst recommendation",
    category: "related categories",
    month: "month",
    volumeGrowth: "volume growth rate",
    interactionGrowth: "interaction growth rate",
    monthVolume: "volume in the current month",
    monthInteraction: "interaction in the current month",
    lastVolume: "volume for the same period last year",
    lastInteraction: "interaction for the same period last year",
    oneMonth: "one month",
    lastThreeMonths: "last three months",
    growth: "growth rate",
    yoy_growth: "Year on year growth rate",
    volume_yoy_growth: "Year on year growth rate of volume",
    interaction_yoy_growth: "Year on year growth rate of interaction",
    sales: "sales volume",
    last_sales: "Sales for the same period last year",
    name: "word",
    keyword: "keyword",
    classification: "classification",
    avg_price: "average price",
    average: "average price of goods",
    form_category_holder: "Please select category",
    form_category_loading: "Loading...",
    form_category_select: "Please select",
    form_category_search_holder: "Press enter",
    form_month_holder: "Please select a month",
    form_keyword_holder: "Please enter keywords (multiple separated by spaces)",
    form_classification_holder: "Please select a category",
    form_sales_min_holder_concept:
      "Filter out concepts larger than this sales amount",
    form_sales_max_holder_concept:
      "Filter out concepts less than this sales amount",
    form_growth_min_holder_concept:
      "Filter out concepts greater than this growth rate",
    form_growth_max_holder_concept:
      "Filter out concepts less than this growth rate",
    form_average_min_holder_concept:
      "Filter out concepts greater than this price",
    form_average_max_holder_concept: "Filter out concepts less than this price",
    form_sales_min_holder_brand:
      "Filter out brands larger than this sales amount",
    form_sales_max_holder_brand:
      "Filter out brands less than this sales amount",
    form_growth_min_holder_brand:
      "Filter out brands greater than this growth rate",
    form_growth_max_holder_brand:
      "Filter out brands less than this growth rate",
    form_average_min_holder_brand: "Filter out brands greater than this price",
    form_average_max_holder_brand: "Filter out brands less than this price",
    form_sales_min_holder_category:
      "Filter out categorys larger than this sales amount",
    form_sales_max_holder_category:
      "Filter out categorys less than this sales amount",
    form_growth_min_holder_category:
      "Filter out categorys greater than this growth rate",
    form_growth_max_holder_category:
      "Filter out categorys less than this growth rate",
    form_average_min_holder_category:
      "Filter out categorys greater than this price",
    form_average_max_holder_category:
      "Filter out categorys less than this price",
    form_placeholder_10k: "10K",
    form_placeholder_unit: "RMB",
  },
  footer: {
    content_one:
      "All data of E-commerce Magic Mirror come from public pages. E-commerce Magic Mirror has no direct connection with Taobao, Tmall, JINGdong,  Amazon and other e-commerce platforms, and is an independent third-party e-commerce data agency  ",
    content_two: "Beijing Taomi Technology Limited Co., LTD. ",
    content_icp: "Beijing ICP 15061734-4 ",
    content_goan: "Beijing network security 11010502037832 ",
    content_add:
      "Data is collected and summarized by the public page, the data caliber is different from that of the platform and other organizations, and it is for reference only. If there is any difference, please refer to the official data released by the platform.",
  },
  setting: {
    phone_set: "Mobile Number Setting",
    mail_set: "Email Setting",
    primary_number: "Your Primary Mobile Number",
    mail_number: "Your email address",
    second_number: "Your Secondary Mobile  Number",
    delete: "Delete",
    phone_placeholder: "Please enter content",
    sms: "SMS login verification",
    add: "Add mobile number",
    add_mail: "Add email",
    success: "Mobile number added successfully",
    confirm: "Confirm",
    dialog_phone: "Primary Mobile Number",
    dialog_input_placeholder: "Enter verification code",
    verification: "Verification",
    cancel: "Cancel",
    yesterday: "yesterday",
    7: "Nearly 7 days",
    30: "Nearly 30 days",
    90: "Nearly 90 days",
    enter_num: "Enter your phone number",
    enter_mail: "Enter your email number",
    enter_correct_num: "Enter the correct phone number",
    enter_correct_mail: "Please enter a valid email",
    first_num: "The first phone number must enable SMS login verification.",
    note: "note",
    optional: "note(optional)",
    desc: "Overseas mobile phone number filling format:+area code mobile phone number",
    example: "For example: +852 61234567",
  },
};
